import classNames from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';
import { FormattedMessage } from 'react-intl';

import { useUrlGenerator } from '../../contexts/RoutesContext';
import NotificationPanel from '../partials/NotificationPanel';

import styles from '../../../styles/notifications/notifications.module.scss';

const propTypes = {
    className: PropTypes.string,
};

const defaultProps = {
    className: null,
};

const DeletedAccount = ({ className }) => {
    const route = useUrlGenerator();
    return (
        <div
            className={classNames(styles.container, {
                [className]: className !== null,
            })}
        >
            <NotificationPanel
                className={styles.notification}
                rounded
                href={route('home')}
                label={
                    <FormattedMessage
                        defaultMessage="Sorry to see you go, your account has been deleted."
                        description="Message"
                    />
                }
            />
        </div>
    );
};

DeletedAccount.propTypes = propTypes;
DeletedAccount.defaultProps = defaultProps;

export default DeletedAccount;
